export default {
    catalogs: {
        bagTypes: 'catalogs/bag-types',
        orderTypes: 'catalogs/order-types',
        handlerStatusListCount: 'catalogs/handler-status-list-count',
        deliveryDesiredDate: 'catalogs/delivery-desired-date',
        sapEventTypes: 'catalogs/sap-event-types',
        sapOperationTypes: 'catalogs/sap-operation-types',
        sapHoldTypes: 'catalogs/sap-hold-types',
    },

    bag: 'bags',

    orders: {
        single: (id) => `/orders/${id}`,
        issuedToCourier: 'orders/issued-to-courier',
        transferredToCourier: 'orders/transferred-to-courier',
        lateOrdersNotification: 'orders/late-orders-notification',
        menuTypes: 'orders/menu-types',
        deliveryParcels: 'orders/delivery-parcels',
        deliveryActInfo: 'orders/delivery-act-info',
        partnerInfo: (id) => `orders/partner-info?partnerId=${id}`,
    },

    orderCheck: {
        basePfm: 'order-check/base-pfm',
    },

    notifications: {
        assemblyReminder: 'notifications/assembly-reminder',
    },

    tasks: {
        root: '/tasks',
        returnFromSbermarketVitrina: '/tasks/return-from-sbermarket-vitrina',
        deliveryList: 'tasks/delivery-list',
        deliveryCount: '/tasks/delivery-count',
    },

    atol: {
        changeStatus: 'atol/change-status',
    },

    acceptanceActs: 'acceptance-acts',
    refunds: 'refunds',
    refundsImport: 'refunds/import',
    refundsPartner: 'refunds/partner',
    refundsPartnerAll: 'refunds/partner-all',
    refundsExport: 'refunds/export',
    feedbacks: 'feedbacks',
    events: {
        base: 'events',
        listCountNotFinished: 'events/list-count-not-finished',
        journal: id => `events/journal/${id}`,
    },

    exchanges: 'exchanges',

    deliveryTare: {
        base: 'delivery-tare',
        remove: 'delivery-tare/remove',
        create: 'delivery-tare/create',
    },

    customers: {
        orders: phone => `customers/orders/${phone}`,
    },

    setKit: (orderId) => `set-kit/${orderId}`,

    testSetKit: {
        list: 'test/set-kit',
        single: (orderId) => `test/set-kit/${orderId}`,
    },

    taskExpired: 'task-expired',

    deliveries: {
        single: (id) => `deliveries/${id}`,
    },

    helpPages: 'help-pages',

    recipients: {
        base: 'recipients',
        types: 'recipients/types',
        rules: 'recipients/rules',
    },

    orderPriority: 'order-priority',

    sap: {
        transactions: 'sap/transactions',
        hold: 'sap/hold',
        batch: 'sap/batch',
        batchById: (id) => `sap/batch/${id}`,
        downloadXlsxByBatchId: (id) => `sap/batch/${id}/xlsx`,
    },

    orderProducts: {
        checkMark: (orderId) => `order-products/${orderId}/mark`,
    },

    admin: {
        moveStatus: 'admin/move-status',
        checkOrderMove: 'admin/check-order-move/',
    },

    orderStatuses: {
        getStatusMove: 'order-statuses/get-status-move',
    },

    alerts: {
        base: 'alerts',
    },
};